/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text } from 'react-native'
import styles from './Styles/ActionSheetComponentStyle'
import { ActionSheetCustom as ActionSheet } from '../Lib/ActionSheet'
import TextComponent from './TextComponent'
import { isIPhoneX } from '../Lib/utils'
import { Fonts } from '../Themes'

export default class ActionSheetComponent extends Component {
  showActionSheet = () => {
    this.ActionSheet.show()
  }

  hide = ()=>{
    this.ActionSheet.hideActionSheet()
  }

  lengthOfStringsInArray = (list) => {
    return list.reduce((total, list) => total + list.length, 0)
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.lengthOfStringsInArray(this.props.options) != this.lengthOfStringsInArray(nextProps.options))
      return true
    return false
  }

  render() {
    const { onPressIndex, options } = this.props
    // const options = [
    //   `repost`, `message kargoer`, `send direct`, `share`, `report`
    // ]
    return (
      <ActionSheet
        ref={o => this.ActionSheet = o}
        tintColor="white"
        buttonUnderlayColor="transparent"
        options={options}
        styles={stylesActionSheet}
        onPress={(index) => onPressIndex(index,options[index])}
      />
    )
  }
}

const stylesActionSheet = {
  buttonBox: {
    height: 30,
    marginBottom: 7.5,
    marginTop: 7.5,
    alignItems: 'center',
    justifyContent: 'center', borderColor: 'white',
    borderRadius: 5,
    borderWidth: 1,
    backgroundColor: 'transparent'
  },
  messageText: {
    color: 'white',
    fontSize: 12
  },
  tintColor: {
    color: 'white'
  },
  buttonText: {
    fontSize: 16,
    fontFamily: Fonts.style.font.light
  },
  viewBox: {
    flex: 1,
    justifyContent: 'space-around'
  },
  body: {
    backgroundColor: Fonts.style.color.baseColor,
    opacity: 0.8,
    paddingLeft: 50,
    paddingRight: 50,
    paddingBottom: isIPhoneX() ? 40 : 20
  }
}
